import Entity from "@mm/state/model/requestModels/Entity";

export default class PageGroupEntity extends Entity {
  static make(botId, name, sortOrder) {
    return {
      ...super.make(),
      botId,
      name,
      sortOrder,
    };
  }
}
